import baseStyles from '../Base/Base.styles'

export default ({ base, color }) => {
  
  let jss = {
    root: {
      ...baseStyles(base),
      color,
      '& .item': {
        display: 'inline-block',
      }
    }
  }

  return jss
}
